/**
 * High-performance, zero-dependency CSV & Excel (.csv/.xlsx-compatible) Export Utility
 */

export function downloadCsv(filename, headers, rows) {
  const escapeField = (val) => {
    if (val === null || val === undefined) return '""';
    const str = String(val).replace(/"/g, '""');
    return `"${str}"`;
  };

  const csvContent = [
    headers.map(escapeField).join(','),
    ...rows.map(row => headers.map(h => escapeField(row[h])).join(','))
  ].join('\r\n');

  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename.endsWith('.csv') ? filename : `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function exportDealerStatement(dealerName, dealerCode, rows, summary = {}) {
  const filename = `Statement_${dealerCode || 'Dealer'}_${new Date().toISOString().slice(0, 10)}.csv`;
  
  const escapeField = (val) => {
    if (val === null || val === undefined) return '""';
    const str = String(val).replace(/"/g, '""');
    return `"${str}"`;
  };

  const headerMeta = [
    `"BHAWAR SALES CORPORATION - DEALER STATEMENT OF ACCOUNT"`,
    `"Dealer: ${dealerName} (${dealerCode || ''})"`,
    `"Generated On: ${new Date().toLocaleDateString('en-IN')}"`,
    `"Total Invoiced: INR ${summary.total_invoiced || 0}"`,
    `"Amount Paid: INR ${summary.amount_paid || 0}"`,
    `"Current Outstanding: INR ${summary.outstanding || 0}"`,
    `""`,
  ];

  const columns = ['Date', 'Document Type', 'Document Number', 'PO Reference', 'Debit (INR)', 'Credit (INR)', 'Balance (INR)', 'Remarks'];
  
  const dataLines = rows.map(r => [
    escapeField(r.doc_date || r.date || ''),
    escapeField(r.doc_type || 'Invoice'),
    escapeField(r.doc_num || r.last_po || ''),
    escapeField(r.po_reference || ''),
    escapeField(r.debit || r.total_invoiced || 0),
    escapeField(r.credit || r.amount_paid || 0),
    escapeField(r.balance || r.outstanding || 0),
    escapeField(r.remarks || 'Standard Billing')
  ].join(','));

  const fullContent = [...headerMeta, columns.map(escapeField).join(','), ...dataLines].join('\r\n');
  const blob = new Blob(['\uFEFF' + fullContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
